import 'css-chunksrc/feature/check-item/CheckItemEditPriceModal.module.scss';export default {
  "currency-input": "CheckItemEditPriceModal_currency-input"
};